import { ReactElement } from 'react';
import { CheckboxInputAccessible } from '@components';
import { useFormikContext, Field } from 'formik';
import { iInstalmentFormValues } from '@services/InstalmentService';

function InstalmentStep14(): ReactElement {
  const { values }: { values: iInstalmentFormValues } = useFormikContext();
  return (
    <>
      <div className="vfH2">Declaration</div>
      { values.isDebtorTypeIndividual && (
        <div>
          <p>I declare that the information that I have supplied in this form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
          <p>I understand that it is an offence under the Fines Reform Act 2014 to intentionally provide false or misleading information in a written statement required by or under the Act. I understand that the offence carries a fine in excess of $1900.</p>
          <p>I understand that if Fines Victoria offers me a payment arrangement, failure to make the first payment by the due date will result in the arrangement being cancelled. This may result in further costs being added to my fine(s) and/or enforcement action being taken against me.</p>
          <p>I confirm that based on my current financial circumstances, I am able to pay the instalments under the proposed payment arrangement.</p>
          <p>I understand that it is my responsibility to ensure that each payment is made on or before the due date.</p>
        </div>
      )}
      { values.isDebtorTypeCompany && (
        <div>
          <p>I declare that I am authorised to act on behalf of the company to complete this application.</p>
          <p>I declare that the information that I have supplied in this form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
          <p>I understand that it is an offence under the Fines Reform Act 2014 to intentionally provide false or misleading information in a written statement required by or under the Act. I understand that the offence carries a fine in excess of $1900.</p>
          <p>I understand that if Fines Victoria offers the company a payment arrangement, failure to make the first payment by the due date may result in the arrangement being cancelled. This may result in further costs being added to my fine(s) and/or enforcement action being taken against the company.</p>
          <p>I understand that it is my responsibility to ensure that each payment is made on or before the due date.</p>
        </div>
      )}

      <Field component={CheckboxInputAccessible} name="declaration" title="I agree to the statements above" />
    </>
  );
}

export default InstalmentStep14;
